export const JOB_MAX_NAME_LENGTH = 40;
export const JOB_MAX_TITLE_LENGTH = 100;
export const JOB_MAX_DESCRIPTION_LENGTH = 1200;
export const JOB_MAX_OCCUPATION_NAME_LENGTH = 25;
export const JOB_MAX_OCCUPATION_NOTE_LENGTH = 600;
export const JOB_MAX_HOLIDAY_NOTE_LENGTH = 200;
export const JOB_MAX_REQUIREMENT_NOTE_LENGTH = 400;
export const JOB_MAX_TREATMENT_NOTE_LENGTH = 400;
export const JOB_MAX_INSURANCE_LENGTH = 200;
export const JOB_MAX_CONTRACT_PERIOD_LENGTH = 200;
export const JOB_MAX_PASSIVE_SMOKING_LENGTH = 100;
export const JOB_MAX_SELECTION_NOTE_LENGTH = 200;
export const JOB_MAX_QUESTION_LENGTH = 200;

export const JOB_PHOTO_MAX_CAPTION_LENGTH = 30;

export const PHONE_RECEPTION_MAX_PHONE_NUMBER_LENGTH = 20;
export const PHONE_RECEPTION_MAX_RECEPTION_TIME_LENGTH = 50;
export const PHONE_RECEPTION_MAX_RECRUITER_NAME_LENGTH = 30;
export const PHONE_RECEPTION_MAX_JOB_NUMBER_LENGTH = 20;

export const SHOP_MAX_NAME_LENGTH = 50;
export const SHOP_MAX_ALT_NAME_LENGTH = 40;
export const SHOP_MAX_DESCRIPTION_LENGTH = 800;
export const SHOP_MAX_ADDRESS_DETAIL_LENGTH = 50;
export const SHOP_MAX_ACCESS_NAME_LENGTH = 30;

export const COMPANY_MAX_NAME_LENGTH = 50;
export const COMPANY_MAX_NAME_ON_RECEIPT_LENGTH = 30;
export const COMPANY_MAX_ADDRESS_DETAIL_LENGTH = 50;
export const COMPANY_MAX_URL_LENGTH = 100;
export const COMPANY_MAX_BUSINESS_DESCRIPTION_LENGTH = 50;
